import styled from "styled-components";
import { assetUrl } from "../utils/assetUrl";
import { motion } from "../../styles/theme";

/**
 * The game's own logotype, lifted out of TheGhostIcon.
 *
 * The app icon itself is a rounded black tile whose lettering occupies a strip
 * of only 382x50 inside a 512x512 canvas. Placed at a 30px header height that
 * lettering renders about 3px tall — an illegible smudge on a black square
 * that all but vanishes against this page's background. So the tile is kept
 * for the favicon (where a square is what's wanted) and the hand-lettered
 * wordmark is cropped out of it for use as the site's logo, where it reads
 * cleanly down to about 20px and replaces both the old ghost glyph and the
 * Oswald text beside it.
 */

/** Intrinsic size of brand/wordmark.webp, used to reserve the right box. */
const NATURAL = { width: 511, height: 90 };

const Img = styled("img")<{ $height: number }>`
  display: block;
  height: ${({ $height }) => $height}px;
  width: auto;
  transition: filter ${motion.base} ${motion.easeOut},
    opacity ${motion.base} ${motion.easeOut};
`;

interface BrandLogoProps {
  /** Rendered height in px; width follows the natural aspect ratio. */
  height?: number;
  className?: string;
  /** Decorative uses (alongside visible text) pass "" to stay silent. */
  alt?: string;
}

export const BrandLogo = ({
  height = 26,
  className,
  alt = "The Ghost",
}: BrandLogoProps) => (
  <Img
    src={assetUrl("/img/brand/wordmark.webp")}
    alt={alt}
    width={Math.round((NATURAL.width * height) / NATURAL.height)}
    height={height}
    $height={height}
    className={className}
    decoding="async"
  />
);

export default BrandLogo;
